import script from "./Record.vue?vue&type=script&setup=true&lang=js"
export * from "./Record.vue?vue&type=script&setup=true&lang=js"

import "./Record.vue?vue&type=style&index=0&id=007e8acb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-007e8acb"]])

export default __exports__